<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in errors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Name Customer"
          v-model="name"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Amount Paid"
          v-model="paid"
          type="number"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Date"
          type="date"
          v-model="date"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="storing"
          @click="store"
        >
          Add
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
  import { errorHandler } from '@/extra-functions/store.extra'
  import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
  export default {
    name: 'create-consumer-loan-transaction',
    props: {
      propConsumerLoanId: String,
      propConsumerId: String,
    },
    data () {
      return {
        name: null,
        date: null,
        paid: null,
        storing: false,
        errors: [],
      }
    },
    methods: {
      store () {
        if (!this.storing) {
          this.storing = true
          this.errors = []
          const data = {
            id: indexKeyGenerator(),
            consumer_loan_id: this.propConsumerLoanId,
            payer_name: this.name,
            date_transaction: this.date,
            amount_paid: this.paid,
          }
          const params = {
            consumer: this.propConsumerId,
            consumerLoan: this.propConsumerLoanId,
          }
          CLTRepository.store(params, data)
            .then(() => { this.resetField() })
            .catch(e => { this.errors = errorHandler(e) })
            .then(() => { this.storing = false })
        }
      },
      resetField () {
        this.name = null
        this.date = null
        this.paid = null
      },
    },
  }
</script>
